import React from 'react';
import { Button, Drawer, Form, Select } from 'antd';

const MobileQuickStatusUpdate = ({
  open,
  loading,
  onClose,
  onSubmit,
  form,
  orderStatusOptions,
  paymentStatusOptions,
  shippingStatusOptions,
  internalStatusOptions,
}) => {
  return (
    <Drawer
      title="Cập nhật nhanh trạng thái"
      placement="bottom"
      open={open}
      onClose={onClose}
      height="auto"
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Trạng thái đơn hàng"
          name="order_status"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái đơn hàng' }]}
        >
          <Select options={orderStatusOptions} />
        </Form.Item>

        <Form.Item
          label="Trạng thái thanh toán"
          name="payment_status_id"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái thanh toán' }]}
        >
          <Select options={paymentStatusOptions} />
        </Form.Item>

        <Form.Item
          label="Trạng thái vận chuyển"
          name="shipping_status_id"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái vận chuyển' }]}
        >
          <Select options={shippingStatusOptions} />
        </Form.Item>

        <Form.Item
          label="Trạng thái nội bộ"
          name="internal_status_id"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái nội bộ' }]}
        >
          <Select options={internalStatusOptions} />
        </Form.Item>
      </Form>
      <div style={{ padding: '8px 0 4px' }}>
        <Button type="primary" block loading={loading} onClick={onSubmit}>
          Lưu
        </Button>
      </div>
    </Drawer>
  );
};

export default MobileQuickStatusUpdate;
